/**
 * Top header on the inbox screen. Shows the app title + a small monogram
 * representing the connected wallet (tap → sign out, in V1; future: profile).
 */
import { useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { shortenAddress } from "../lib/format";
import { WalletIcon } from "./Icons";

export function InboxHeader(): JSX.Element {
  const { me, signOut } = useAuth();
  const [showMenu, setShowMenu] = useState(false);

  return (
    <header className="safe-top sticky top-0 z-10 border-b border-tg-separator bg-tg-bg px-4 py-2.5">
      <div className="flex items-center justify-between">
        <h1 className="text-[17px] font-semibold text-tg-text">Tolkgram</h1>
        <div className="relative">
          <button
            type="button"
            onClick={() => setShowMenu((v) => !v)}
            className="flex items-center gap-1.5 rounded-full bg-tg-secondary-bg px-3 py-1 text-[12px] text-tg-text"
            aria-label="Wallet"
            aria-expanded={showMenu}
          >
            <WalletIcon size={14} />
            <span className="font-mono">
              {me ? shortenAddress(me.wallet_address_friendly) : "—"}
            </span>
          </button>
          {showMenu ? (
            <div
              className="absolute right-0 top-full z-20 mt-1 w-40 rounded-md border border-tg-separator bg-tg-tertiary-bg p-1 shadow-lg"
              role="menu"
            >
              <button
                type="button"
                onClick={() => {
                  setShowMenu(false);
                  void signOut();
                }}
                className="block w-full rounded-sm px-3 py-2 text-left text-[13px] text-tg-destructive hover:bg-tg-secondary-bg"
                role="menuitem"
              >
                Sign out
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </header>
  );
}
